function ParallaxScrolling(container) {
    this.container = container;

    // Setup the controller
    const controller = new ScrollMagic.Controller({ globalSceneOptions: { duration: '100%' } });
    const enterController = new ScrollMagic.Controller({ globalSceneOptions: { triggerHook: 'onEnter', duration: '200%' } });

    const title = container.querySelector('.jsHomeIntroTitle');
    const contentWrapper = container.querySelector('.jsHomeIntroContentWrapper');
    const videoWrapper = container.querySelector('.jsDocumentaryPreviewElements > div');

    if (videoWrapper && contentWrapper) {
        const scene = new ScrollMagic.Scene({ triggerElement: contentWrapper })
            .setTween([title, contentWrapper], { y: '-200%', opacity: 0, ease: Power0.easeNone })
            .addTo(controller)
        ;

        if (window.innerWidth < 850) scene.enabled(false);
        else scene.enabled(true);

        window.addEventListener('resize', _ => {
            if (window.innerWidth < 850) scene.enabled(false);
            else scene.enabled(true);
        });
    }

    // Animate the tour background images
    const tourBg1 = this.container.querySelector('.jsTourAlbumRows .row1');
    const tourBg2 = this.container.querySelector('.jsTourAlbumRows .row2');

    new ScrollMagic.Scene({ triggerElement: tourBg1 })
        .setTween(tourBg1, { x: '-3%', ease: Power0.easeNone })
        .addTo(enterController);
    ;

    new ScrollMagic.Scene({ triggerElement: tourBg2 })
        .setTween(tourBg2, { x: '3%', ease: Power0.easeNone })
        .addTo(enterController);
    ;
};